{
  "aiGeneratedAnswer": "Réponse générée par l'IA",
  "allCategories": "Toutes les catégories",
  "appliedFiltersToCurrentSearch": "Filtres appliqués à la recherche actuelle",
  "apply": "Appliquer",
  "applyFilters": "Appliquer les filtres",
  "autocompleteOptionsFound_many": "{{count}} options d'autocomplétion{{label}} trouvées.",
  "autocompleteOptionsFound_one": "{{count}} option d'autocomplétion{{label}} trouvée.",
  "autocompleteOptionsFound_other": "{{count}} options d'autocomplétion{{label}} trouvées.",
  "autocompleteSuggestion": "suggestion de saisie semi-automatique: {{suggestion}}",
  "autocompleteSuggestionsFound_many": "{{count}} suggestions d'autocomplétion trouvées.",
  "autocompleteSuggestionsFound_one": "{{count}} suggestion d'autocomplétion trouvée.",
  "autocompleteSuggestionsFound_other": "{{count}} suggestions d'autocomplétion trouvées.",
  "basedOnYourDevice": " (basé sur votre appareil)",
  "basedOnYourInternetAddress": " (basé sur votre adresse Internet)",
  "categoriesText_one": "La catégorie suivante a donné des résultats pour - <strong>{{query}}</strong>",
  "categoriesText_other": "Les catégories suivantes ont donné des résultats pour - <strong>{{query}}</strong>",
  "clearAll": "Effacer tout",
  "clearMinAndMax": "Effacer min et max",
  "clearTheRangeToSelectOptions": "Effacer la plage pour sélectionner les options.",
  "clearTheSearchBar": "Effacer la barre de recherche",
  "conductASearch": "Effectuer une recherche",
  "currentLocation": "Localisation actuelle",
  "didYouMean": "Vouliez-vous dire <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Lorsque des résultats de saisie semi-automatique sont disponibles, utilisez les flèches haut et bas pour naviguer et appuyez sur Entrée pour sélectionner.",
  "feedback": "Retour",
  "filterGroupSearchInputLabel": "Rechercher parmi les options de {{title}}",
  "invalidRange": "Gamme non valide",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Accédez à la page de résultats suivante",
  "navigateToThePreviousResultsPage": "Accédez à la page de résultats précédents",
  "noAutocompleteOptionsFound": "0 option de saisie semi-automatique trouvée.",
  "noAutocompleteSuggestionsFound": "0 suggestion de saisie semi-automatique trouvées.",
  "noResultsFoundIn": "Aucun résultat trouvé dans {{currentVerticalLabel}}.",
  "paginationPage": "page {{pageNumber}}",
  "pagination": "Pagination",
  "readMoreAbout": "En savoir plus sur <a>{{name}}</a>",
  "recentSearch": "recherche récente : {{query}}",
  "recentSearchesFound_many": "{{count}} recherches récentes trouvées.",
  "recentSearchesFound_one": "{{count}} recherche récente trouvée.",
  "recentSearchesFound_other": "{{count}} recherches récentes trouvées.",
  "removeFilter": "Supprimer le filtre «{{displayName}}»",
  "resultPreview": "aperçu du résultat: {{value}}",
  "resultPreviewsFound_many": "{{count}} aperçus de résultats trouvés.",
  "resultPreviewsFound_one": "{{count}} aperçu de résultat trouvé.",
  "resultPreviewsFound_other": "{{count}} aperçus de résultats trouvés.",
  "resultsCountText_many": "{{count}} résultats",
  "resultsCountText_one": "{{count}} résultat",
  "resultsCountText_other": "{{count}} résultats",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} sur {{resultsCount}} résultats",
  "searchHere": "Recherche ici…",
  "showingAllInstead": "Affichage de tous les {{currentVerticalLabel}} à la place.",
  "showLess": "Afficher moins",
  "showMore": "Afficher plus",
  "sources_many": "Sources ({{count}})",
  "sources_one": "Source",
  "sources_other": "Sources ({{count}})",
  "submitSearch": "Soumettre la recherche",
  "suggestionResultsCount_many": "{{label}} - {{count}} résultats",
  "suggestionResultsCount_one": "{{label}} - {{count}} résultat",
  "suggestionResultsCount_other": "{{label}} - {{count}} résultats",
  "thankYouForYourFeedback": "Merci pour votre retour !",
  "thisAnsweredMyQuestion": "Cela a répondu à ma question",
  "thisDidNotAnswerMyQuestion": "Cela n'a pas répondu à ma question",
  "unselectAnOptionToEnterInARange": "Désélectionnez une option pour saisir une plage.",
  "updateYourLocation": "Mettez à jour votre emplacement",
  "useCurrentLocation": "Utiliser la localisation actuelle",
  "useMyLocation": "Utiliser ma localisation",
  "viewAll": "Afficher tous",
  "viewDetails": "Afficher les détails"
}
